<script>
    export default {
        name: "ImageResponsive",
        props: {
            mobile: String,
            mobileWebp: String,
            desktop: String,
            desktopX2: String,
            desktopWebp: String,
            className: String,
            breakpoint: {
                type: String,
                default: "991",
            },
            alt: {
                type: String,
                default: "",
            },
        },
    };
</script>

<template>
    <picture>
        <source
            v-if="mobileWebp"
            :media="`(max-width: ${breakpoint}px)`"
            :srcset="mobileWebp"
            type="image/webp"
        />
        <source v-if="desktopWebp" :srcset="desktopWebp" type="image/webp" />
        <source v-if="mobile" :media="`(max-width: ${breakpoint}px)`" :srcset="mobile" />
        <source v-if="desktopX2" :srcset="desktopX2 + ' 2x, ' + desktop + ' 1x '" />
        <img :class="className" :src="desktop" :alt="alt" />
    </picture>
</template>
